import { useCallback, useEffect, useState } from "react";
import { HEADING_HEIGHT, ROW_HEIGHT } from "./constants.js";

interface UseCalculatedPageSizeOptions {
  pageSize: number | "max";
}

interface UseCalculatedPageSize {
  calculatedPageSize: number;
  tableContainerRef: (tableContainer: HTMLDivElement | null) => void;
}

export default function useCalculatedPageSize({
  pageSize,
}: UseCalculatedPageSizeOptions): UseCalculatedPageSize {
  const [tableContainer, setTableContainer] = useState<HTMLDivElement | null>(
    null,
  );
  const [measuredPageSize, setMeasuredPageSize] = useState(0);

  const tableContainerRef = useCallback((node: HTMLDivElement | null) => {
    setTableContainer(node);
  }, []);

  useEffect(() => {
    if (pageSize !== "max") {
      return;
    }

    if (!tableContainer) {
      return;
    }

    const calculatePageSize = () => {
      const availableHeight = tableContainer.getBoundingClientRect().height;
      const rowsHeight = availableHeight - HEADING_HEIGHT;
      const newPageSize = Math.max(1, Math.floor(rowsHeight / ROW_HEIGHT));
      setMeasuredPageSize(newPageSize);
    };

    calculatePageSize();

    const resizeObserver = new ResizeObserver(calculatePageSize);
    resizeObserver.observe(tableContainer);
    return () => resizeObserver.disconnect();
  }, [pageSize, tableContainer]);

  return {
    calculatedPageSize: pageSize === "max" ? measuredPageSize : pageSize,
    tableContainerRef,
  };
}
